import React from "react";
import { useTranslation } from "react-i18next";
import { CheckCircle } from "lucide-react";
import type { WizardState } from "./OnboardingWizard";

interface Props {
  createdMembers: WizardState["createdMembers"];
  onComplete: () => Promise<void>;
  isLoading: boolean;
}

const Step4Success: React.FC<Props> = ({
  createdMembers,
  onComplete,
  isLoading,
}) => {
  const { t } = useTranslation("auth");

  return (
    <div className="wizard-step-content">
      <div className="success-content">
        <div className="success-icon">
          <CheckCircle size={36} color="#16A34A" />
        </div>
        <h2>{t("onboarding.success.title")}</h2>
        <p className="step-description">
          {t("onboarding.success.description")}
        </p>

        {createdMembers.length > 0 && (
          <div className="created-members-list">
            <h4>{t("onboarding.success.teamAccountsTitle")}</h4>
            {createdMembers.map((member) => (
              <div key={member.id} className="created-member-row">
                <span className="created-member-email">
                  {member.email} ({member.role})
                </span>
                <span className="created-member-password">
                  {member.tempPassword}
                </span>
              </div>
            ))}
          </div>
        )}
      </div>

      <div className="wizard-actions">
        <div />
        <button
          className="btn-primary"
          onClick={onComplete}
          disabled={isLoading}
        >
          {isLoading
            ? t("onboarding.success.actions.saving")
            : t("onboarding.success.actions.goToDashboard")}
        </button>
      </div>
    </div>
  );
};

export default Step4Success;
